/* ============================================================
   FLIPSIDE ABOUT — flipside-about.js
   ============================================================ */

(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function lerp(a, b, t) { return a + (b - a) * t; }
  function clamp(v, lo, hi) { return Math.min(Math.max(v, lo), hi); }
  function norm(v, lo, hi) { return clamp((v - lo) / (hi - lo), 0, 1); }

  function initAbout(section) {

    // ── Apply background colour from schema ──
    const bg = section.dataset.bg;
    if (bg) section.style.backgroundColor = bg;

    // ── Scroll reveal — text and badge ──
    const revealEls  = section.querySelectorAll('[data-about-reveal]');
    const badgeEl    = section.querySelector('[data-about-badge]');

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    revealEls.forEach(el => io.observe(el));
    if (badgeEl) io.observe(badgeEl);

    if (reduceMotion) return;

    // ── Ken Burns — video gently scales out as you scroll into section ──
    const video = section.querySelector('.flipside-about__video');

    // ── Can parallax — each can drifts at a different rate ──
    const canData = [
      { el: section.querySelector('.flipside-about__float-can--1'), speed:  0.08 },
      { el: section.querySelector('.flipside-about__float-can--2'), speed: -0.06 },
      { el: section.querySelector('.flipside-about__float-can--3'), speed:  0.12 },
      { el: section.querySelector('.flipside-about__float-can--4'), speed: -0.09 },
    ].filter(c => c.el !== null);

    canData.forEach(c => { c.curY = 0; c.tarY = 0; });

    let videoScale     = 1.05;
    let videoScaleCur  = 1.05;

    function updateTargets() {
      const rect     = section.getBoundingClientRect();
      const vh       = window.innerHeight;
      const progress = norm(rect.top, vh, -rect.height);

      // Ken Burns: scale from 1.05 down to 1.0 as section scrolls through
      videoScale = 1.05 - progress * 0.05;

      // Can parallax
      canData.forEach(c => {
        c.tarY = progress * c.speed * 120;
      });
    }

    function tick() {
      requestAnimationFrame(tick);

      // Lerp video scale
      videoScaleCur = lerp(videoScaleCur, videoScale, 0.05);
      if (video) {
        video.style.transform = `scale(${videoScaleCur})`;
      }

      // Lerp can positions
      canData.forEach(c => {
        c.curY = lerp(c.curY, c.tarY, 0.06);
        c.el.style.marginTop = `${c.curY}px`;
      });
    }

    window.addEventListener('scroll', updateTargets, { passive: true });
    updateTargets();
    tick();
  }

  // ── Boot ──
  function boot() {
    document.querySelectorAll('.flipside-about').forEach(initAbout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', e => {
    const s = e.target.querySelector('.flipside-about');
    if (s) initAbout(s);
  });

})();